import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import cardTypes from '../../data/cardTypes'
import types from '../../data/types'
import { cardTypeIcons } from '../../images'

const CardTypeIcon = ({ cardType, type }) => {
	if (cardType && !cardTypes[cardType]) {
		return 'Card type not found'
	}

	if (type && !types.find(item => item.value === type)) {
		return 'Type not found'
	}

	const cardTypeData = cardTypes[cardType]
	const typeData = types.find(item => item.value === type)
	const color = cardTypeData?.iconColor ? cardTypeData.iconColor : typeData.iconColor
	const bottomGradientColor = cardTypeData?.bottomGradientColor ? cardTypeData.bottomGradientColor : typeData.bottomGradientColor

	if (cardType && cardTypeIcons[cardType]) {
		return (
			<StyledCardTypeImage>
				<img src={cardTypeIcons[cardType]} alt="" />
			</StyledCardTypeImage>
		)
	}

	return (
		<StyledCardTypeIcon color={color} bottomGradientColor={bottomGradientColor}>
			<BorderSide color={color} />
			<InnerBorder>
				<BlankImage />
			</InnerBorder>
			<BorderSide color={bottomGradientColor || color} />
		</StyledCardTypeIcon>
	)
}

CardTypeIcon.propTypes = {
	cardType: PropTypes.number,
	type: PropTypes.string
}

CardTypeIcon.defaultProps = {
	cardType: null,
	type: null
}

export const StyledCardTypeIcon = styled.div`
	border-color: rgba(0, 0, 0, 0.15);
	border-style: solid;
	border-width: 0 1px 0;
	border-radius: 1px;

	${props => props.bottomGradientColor ? `
		background: linear-gradient(to bottom, ${props.color} 35%, ${props.bottomGradientColor});
	` : `
		background: ${props.color};
	`}

	height: 30px;
	width: 21px;

	position: relative;

	display: flex;
	flex-direction: column;
	justify-content: space-between;
`

const InnerBorder = styled.div`
	border: 1px solid ${props => props.theme.id === 'dark' ? 'rgba(255, 255, 255, 0.15)' : 'rgba(0, 0, 0, 0.15)'};

	position: absolute;
	top: 5px;
	left: 2px;
`

const BlankImage = styled.div`
	background: ${props => props.theme.background};

	height: 13px;
	width: 13px;
`

const BorderSide = styled.div`
	background: ${props => props.color};
	border-radius: 2px;
	border-top: 1px solid ${props => props.theme.id === 'dark' ? 'rgba(255, 255, 255, 0.15)' : 'rgba(0, 0, 0, 0.15)'};
	height: 1px;
	width: 21px;
	margin-left: -1px;
`

export const StyledCardTypeImage = styled.div`
	&, img {
		height: 22px;
		width: 22px;
		min-width: 22px;
	}
`

export default CardTypeIcon
